export const LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS';
export const LOAD_NOTIFICATIONS_PAGE = 'LOAD_NOTIFICATIONS_PAGE';
export const READ_NOTIFICATION = 'READ_NOTIFICATION';
